export default __webpack_public_path__ + "static/media/styles.e2d49931.less";